module.exports = __webpack_public_path__ + "img/connection-left-1.9a685040.png";